import type { FC } from 'react';
import { Box, Grid2 } from '@mui/material';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import HomeImage from '/public/images/home/homeFooter.svg';

const Dashboard: FC = () => {
  const t = useTranslations('Home');
  return (
    <Grid2 size={12} container data-aos="fade-up">
      <Grid2 sx={{ textAlign: 'center' }} size={12}>
        <Box
          // color="text.light"
          sx={{
            fontSize: {
              xs: '32px',
              md: '40px',
            },
            fontWeight: 700,
            color: '#000',
          }}
        >
          {t('dashboardTitle')}
        </Box>
      </Grid2>
      <Grid2
        sx={{ textAlign: 'center' }}
        my={1}
        size={12}
        justifyContent="center"
        display="flex"
      >
        <Grid2
          size={{
            xs: 12,
            md: 8,
          }}
        >
          <Box
            sx={{
              fontWeight: 400,
              color: '#677788',
              fontSize: {
                xs: '14px',
                md: '20px',
              },
            }}
          >
            {t('dashboardDescription')}
          </Box>
        </Grid2>
      </Grid2>
      <Grid2 container size={12} data-aos="fade-up">
        <Image
          alt="Home Image"
          src={HomeImage}
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'contain',
          }}
        />
      </Grid2>
    </Grid2>
  );
};

export default Dashboard;
